import { render, staticRenderFns } from "./BlockHead.vue?vue&type=template&id=6bfa39a1&scoped=true"
import script from "./BlockHead.vue?vue&type=script&lang=js"
export * from "./BlockHead.vue?vue&type=script&lang=js"
import style0 from "./BlockHead.vue?vue&type=style&index=0&id=6bfa39a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfa39a1",
  null
  
)

export default component.exports